import { render, staticRenderFns } from "./FullScreenLockedApp.vue?vue&type=template&id=a8ae6814&scoped=true&"
import script from "./FullScreenLockedApp.vue?vue&type=script&lang=js&"
export * from "./FullScreenLockedApp.vue?vue&type=script&lang=js&"
import style0 from "./FullScreenLockedApp.vue?vue&type=style&index=0&id=a8ae6814&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ae6814",
  null
  
)

export default component.exports